import {
  ArrowRightIcon,
  Box,
  Card,
  Stack,
  Typography,
} from "@datanomik/commons-ui";

export type RuleCreationTypeCardProps = {
  name: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
};

export const RuleCreationTypeCard = (props: RuleCreationTypeCardProps) => {
  const { name, description, icon, onClick } = props;

  return (
    <Card
      sx={{
        padding: 0,
        overflow: "hidden",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        onClick={onClick}
        sx={{
          cursor: "pointer",
          p: 2,
          "& .arrow": {
            opacity: 0.5,
            transform: "translateX(-2px)",
            transition: "all 0.2s",
          },
          "&:hover": {
            backgroundColor: "action.hover",
            "& .arrow": {
              opacity: 1,
              transform: "translateX(0)",
            },
          },
        }}
      >
        {icon}
        <Stack flex={1}>
          <Typography fontWeight={500}>{name}</Typography>
          <Typography fontSize="12px" color="textSecondary">
            {description}
          </Typography>
        </Stack>
        <Box className="arrow">
          <ArrowRightIcon />
        </Box>
      </Stack>
    </Card>
  );
};
